import { ShopigurusHTMLElement } from '@shopigurus/base';

class ShpfltShopTheLook extends ShopigurusHTMLElement {
  connectedCallback() {
    super.connectedCallback();
    
    // Initialize any interactive features here
    this.#initImageLazyLoading();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    // Cleanup if needed
  }

  onSectionSelect() {
    // Keep section visible for merchant in theme editor
    this.classList.add('editor-selected');
  }

  onSectionDeselect() {
    // Remove editor selection styling
    this.classList.remove('editor-selected');
  }

  #initImageLazyLoading() {
    const images = this.querySelectorAll('img[loading="lazy"]');
    
    // Enhance lazy loading with intersection observer for better performance
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const img = entry.target;
              // Image is about to be visible, ensure it loads properly
              if (img.dataset.src) {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
              }
              imageObserver.unobserve(img);
            }
          });
        },
        {
          rootMargin: '50px 0px', // Start loading 50px before image enters viewport
          signal: this.abortController.signal
        }
      );

      images.forEach((img) => imageObserver.observe(img));
    }
  }
}

customElements.define('shpflt-shop-the-look', ShpfltShopTheLook);